import React from 'react';
import './goBack.scss';
function GoBack (props) {
  return (
        <div className='goBack-btn' onClick={props.goBack}>
            <div className='goBack-btn-container'>
                <img src='/media/icons/inclassica/arrow-left-white.svg' alt='go-back-btn'/>
                <span>BACK</span>
            </div>
        </div>
  );
}
export default GoBack;
